// Single source of truth for details that appear on every page.
// Copy here follows the Brand Guide voice rules: British English, no
// exclamation marks, no emoji, prices written as £14 (never £14.00).

export const site = {
  name: 'VelvetMitten',
  locality: 'Fareham',
  areaLine: 'Fareham & surrounding area, Hampshire',
  blurb:
    'Professional in-home cat and dog sitting across Fareham and the surrounding area.',
  owner: 'Kirsty',
  phone: '01234 567890',
  phoneHref: 'tel:01234567890',
  email: 'k@k.com',
  emailHref: 'mailto:k@k.com',
  copyright: '© 2026 VelvetMitten · Fareham, Hampshire',
};

export const nav = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services & Pricing' },
  { to: '/about', label: 'About' },
  { to: '/testimonials', label: 'Testimonials' },
  { to: '/faq', label: 'FAQ' },
  { to: '/blog', label: 'Blog' },
];

// The footer lists Contact as well; the header keeps it as the CTA button.
export const footerNav = [...nav, { to: '/contact', label: 'Contact' }];

// These three appear together, in this order, above the fold on every
// page (Brand Guide — Elements). Never reorder or bury them.
export const trustPills = [
  'Fully insured',
  'DBS checked',
  'Free meet & greet',
];

export const serviceAreas = [
  'Portchester',
  'Titchfield',
  'Stubbington',
  'Hill Head',
  'Whiteley',
  'Funtley',
  'Catisfield',
  'Wickham',
];
